import { render } from "./TableAuditoria.vue?vue&type=template&id=632c1e47&scoped=true"
import script from "./TableAuditoria.vue?vue&type=script&lang=js"
export * from "./TableAuditoria.vue?vue&type=script&lang=js"

import "./TableAuditoria.vue?vue&type=style&index=0&id=632c1e47&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-632c1e47"]])

export default __exports__